import React, { useState } from "react";
import { formatINR, sumField, safeArray } from "egov-ui-kit/utils/commons";

const LEVELS = [{ key: "ulbs", label: "ULB Name", childKey: null }];

const GLDetailTable = ({ item, financialYear, ulbName, onBack, totalOpeningBalanceSum }) => {
  const receipts = safeArray(item.openingBalanceDetail);
  const totalDebit = receipts.reduce((acc, r) => acc + Number(r.debitAmount || 0), 0);
  const totalCredit = receipts.reduce((acc, r) => acc + Number(r.creditAmount || 0), 0);

  return (
    <div className="receipt-card">
      {/* HEADER */}
      <div className="zone-wise-header">
        <div className="header wrapper-header">
          <button className="btn btn-secondary back-button" onClick={onBack}>
            Back
          </button>
          <div>
            <h2>{item.name}</h2>
          </div>
        </div>
        <div className="receipt-header">
          <span>Financial Year : {financialYear}</span>
          <span>|</span>
          <span>ULB : {ulbName}</span>
        </div>
      </div>

      {/* DETAIL TABLE */}
      <div className="table-responsive scrolling-table">
        <table className="table receipt-table mb-0">
          <thead>
            <tr>
              <th>Account Name</th>
              <th style={{ width: "160px" }}>Account Code</th>
              <th>Debit (₹)</th>
              <th>Credit (₹)</th>
            </tr>
          </thead>
          <tbody>
            {receipts.length > 0 ? (
              <React.Fragment>
                {receipts.map((r) => {
                  const debit = Number(r.debitAmount || 0);
                  const credit = Number(r.creditAmount || 0);
                  return (
                    <tr key={r.id}>
                      <td>{r.accountName}</td>
                      <td>{r.accountCode}</td>
                      <td>{debit > 0 ? formatINR(debit) : "-"}</td>
                      <td>{credit > 0 ? formatINR(credit) : "-"}</td>
                    </tr>
                  );
                })}
              </React.Fragment>
            ) : (
              <tr>
                <td colSpan="4" style={{ textAlign: "center" }}>
                  No Records Found
                </td>
              </tr>
            )}
          </tbody>
          {receipts.length > 0 && (
            <tfoot className="tfoot-bottom">
              <tr className="total-row">
                <td style={{ textAlign: "left" }} colSpan="2">
                  Total
                </td>
                <td>{formatINR(totalDebit)}</td>
                <td>{formatINR(totalCredit)}</td>
              </tr>
            </tfoot>
          )}
        </table>
      </div>
    </div>
  );
};

const OpeningBalanceTable = ({ openingBalanceDetails }) => {
  const tableData = openingBalanceDetails && openingBalanceDetails;
  console.log("tableData",tableData)
  const totalOpeningBalanceSum = safeArray(tableData.ulbs).reduce((acc, ulb) => acc + (Number(ulb.totalOpeningBalance) || 0), 0);

  const [selectedReceipt, setSelectedReceipt] = useState(null);

  if (selectedReceipt) {
    return (
      <GLDetailTable
        item={selectedReceipt}
        financialYear={tableData.financialYear}
        ulbName={tableData.ulbName}
        totalOpeningBalanceSum={totalOpeningBalanceSum}
        onBack={() => setSelectedReceipt(null)}
      />
    );
  }

  const levelConfig = LEVELS[0];
  const currentRows = safeArray(tableData[levelConfig.key]);
  const currentTitle = "ULB Wise Opening Balance";

  const totalsRow = tableData.totals;

  const handleDrillDown = (ulb) => {
    setSelectedReceipt(ulb);
  };

  return (
    <div className="receipt-card">
      {/* HEADER */}
      <div className="zone-wise-header">
        <div className="header wrapper-header">
          <div className="icon-wrapper">
            <i className="material-icons">description</i>
          </div>
          <div>
            <h2>{currentTitle}</h2>
          </div>
        </div>
        <div className="receipt-header">
          <span>Financial Year : {tableData.financialYear}</span>
          <span>|</span>
          <span>ULB : {tableData.ulbName}</span>
        </div>
      </div>

      {/* MAIN DATA TABLE */}
      <div className="table-responsive scrolling-table">
        <table className="table receipt-table mb-0">
          <thead>
            <tr>
              <th>{levelConfig.label}</th>
              <th>Opening Balance</th>
            </tr>
          </thead>
          <tbody>
            {currentRows.length > 0 ? (
              <React.Fragment>
                {currentRows.map(function (item) {
                  return (
                    <tr key={item.id}>
                      <td>{item.name}</td>
                      <td>
                        <a
                          href="#"
                          className="link-cell"
                          onClick={function (e) {
                            e.preventDefault();
                            handleDrillDown(item);
                          }}
                        >
                          {formatINR(item.totalOpeningBalance)}
                        </a>
                      </td>
                    </tr>
                  );
                })}
              </React.Fragment>
            ) : (
              <tr>
                <td colSpan="2" style={{ textAlign: "center" }}>
                  No Record Found
                </td>
              </tr>
            )}
          </tbody>

          {currentRows.length > 0 && (
            <tfoot className="tfoot-bottom">
              <tr className="total-row">
                <td style={{ textAlign: "left" }}>Total</td>
                <td>{formatINR(totalOpeningBalanceSum)}</td>
              </tr>
            </tfoot>
          )}
        </table>
      </div>
    </div>
  );
};

export default OpeningBalanceTable;



// WEBPACK FOOTER //
// src/modules/employee/Home/OpeningBalanceTable.js